<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm6>
      <v-card >
        <v-toolbar dark color="primary">
          <v-toolbar-title>Text Opt-In</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <div class="headline mx-4">
                  Please select Yes to Opt-In to St. Paul sending text messages to you. Or, you can choose No to not recieve text messages.<br/>
                  You can change the option at any time by updating your profile.
                </div>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="optIns"
                  v-model="textOptIn"
                  menu-props="auto"
                  label="Text Opt In"
                  hide-details
                  @keyup.enter="save"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveOptIn">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'

export default {
  data: () => ({
    currentPage: 'Settings',
    userId: 0,
    optIns: [
      { text: 'Yes', value: true },
      { text: 'No', value: false }
    ],
    textOptIn: '',
    snackbar: {
      show: false,
      color: '',
      message: ''
    }
  }),

  created () {
    this.$store.dispatch('setCurrentPage', this.currentPage)
    this.currentYear = this.$store.state.currentYear
    this.userId = this.$store.state.user.id
  },

  methods: {
    async saveOptIn () {
      try {
        let member = {}

        member.textOptIn = this.textOptIn
        member.userId = this.userId
        const response = await Api().post('set_handbook', member)

        // console.log('res', response)
        this.$router.push({
          name: 'dashboard'
        })

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/OptIn.vue